/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { EHopeApprenantSearchTypeListSearch } from './EHopeApprenantSearchTypeListSearch';
import {
    EHopeApprenantSearchTypeListSearchFromJSON,
    EHopeApprenantSearchTypeListSearchFromJSONTyped,
    EHopeApprenantSearchTypeListSearchToJSON,
} from './EHopeApprenantSearchTypeListSearch';
import type { ESearchStatutInscriptionListSearch } from './ESearchStatutInscriptionListSearch';
import {
    ESearchStatutInscriptionListSearchFromJSON,
    ESearchStatutInscriptionListSearchFromJSONTyped,
    ESearchStatutInscriptionListSearchToJSON,
} from './ESearchStatutInscriptionListSearch';
import type { FilterTextSearch } from './FilterTextSearch';
import {
    FilterTextSearchFromJSON,
    FilterTextSearchFromJSONTyped,
    FilterTextSearchToJSON,
} from './FilterTextSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { NumericSearch } from './NumericSearch';
import {
    NumericSearchFromJSON,
    NumericSearchFromJSONTyped,
    NumericSearchToJSON,
} from './NumericSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ApprenantHopeSearch
 */
export interface ApprenantHopeSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantHopeSearch
     */
    nomSa?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantHopeSearch
     */
    prenomSa?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantHopeSearch
     */
    anneeScolaireCriteria?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantHopeSearch
     */
    telephone?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantHopeSearch
     */
    gsm?: TextSearch;
    /**
     * 
     * @type {FilterTextSearch}
     * @memberof ApprenantHopeSearch
     */
    classeCriteria?: FilterTextSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    centreCriteria?: StringListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    degreCriteria?: StringListSearch;
    /**
     * 
     * @type {NumericSearch}
     * @memberof ApprenantHopeSearch
     */
    idapprenant?: NumericSearch;
    /**
     * 
     * @type {EHopeApprenantSearchTypeListSearch}
     * @memberof ApprenantHopeSearch
     */
    mesApprenants?: EHopeApprenantSearchTypeListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ApprenantHopeSearch
     */
    enrechercheEntreprise?: BooleanSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    metierContrat?: StringListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    metierCriteria?: StringListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    stadeContrat?: StringListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    stadeCriteria?: StringListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ApprenantHopeSearch
     */
    serviceContrat?: Int32ListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    typeContrat?: StringListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantHopeSearch
     */
    registreNationalOrEmpty?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ApprenantHopeSearch
     */
    idpri?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ApprenantHopeSearch
     */
    idari?: Int32ListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantHopeSearch
     */
    statutContrat?: StringListSearch;
    /**
     * 
     * @type {ESearchStatutInscriptionListSearch}
     * @memberof ApprenantHopeSearch
     */
    statutInscription?: ESearchStatutInscriptionListSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprenantHopeSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ApprenantHopeSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantHopeSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantHopeSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ApprenantHopeSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantHopeSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ApprenantHopeSearch interface.
 */
export function instanceOfApprenantHopeSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantHopeSearchFromJSON(json: any): ApprenantHopeSearch {
    return ApprenantHopeSearchFromJSONTyped(json, false);
}

export function ApprenantHopeSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantHopeSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nomSa': !exists(json, 'nomSa') ? undefined : TextSearchFromJSON(json['nomSa']),
        'prenomSa': !exists(json, 'prenomSa') ? undefined : TextSearchFromJSON(json['prenomSa']),
        'anneeScolaireCriteria': !exists(json, 'anneeScolaireCriteria') ? undefined : TextSearchFromJSON(json['anneeScolaireCriteria']),
        'telephone': !exists(json, 'telephone') ? undefined : TextSearchFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TextSearchFromJSON(json['gsm']),
        'classeCriteria': !exists(json, 'classeCriteria') ? undefined : FilterTextSearchFromJSON(json['classeCriteria']),
        'centreCriteria': !exists(json, 'centreCriteria') ? undefined : StringListSearchFromJSON(json['centreCriteria']),
        'degreCriteria': !exists(json, 'degreCriteria') ? undefined : StringListSearchFromJSON(json['degreCriteria']),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : NumericSearchFromJSON(json['idapprenant']),
        'mesApprenants': !exists(json, 'mesApprenants') ? undefined : EHopeApprenantSearchTypeListSearchFromJSON(json['mesApprenants']),
        'enrechercheEntreprise': !exists(json, 'enrechercheEntreprise') ? undefined : BooleanSearchFromJSON(json['enrechercheEntreprise']),
        'metierContrat': !exists(json, 'metierContrat') ? undefined : StringListSearchFromJSON(json['metierContrat']),
        'metierCriteria': !exists(json, 'metierCriteria') ? undefined : StringListSearchFromJSON(json['metierCriteria']),
        'stadeContrat': !exists(json, 'stadeContrat') ? undefined : StringListSearchFromJSON(json['stadeContrat']),
        'stadeCriteria': !exists(json, 'stadeCriteria') ? undefined : StringListSearchFromJSON(json['stadeCriteria']),
        'serviceContrat': !exists(json, 'serviceContrat') ? undefined : Int32ListSearchFromJSON(json['serviceContrat']),
        'typeContrat': !exists(json, 'typeContrat') ? undefined : StringListSearchFromJSON(json['typeContrat']),
        'registreNationalOrEmpty': !exists(json, 'registreNationalOrEmpty') ? undefined : TextSearchFromJSON(json['registreNationalOrEmpty']),
        'idpri': !exists(json, 'idpri') ? undefined : Int32ListSearchFromJSON(json['idpri']),
        'idari': !exists(json, 'idari') ? undefined : Int32ListSearchFromJSON(json['idari']),
        'statutContrat': !exists(json, 'statutContrat') ? undefined : StringListSearchFromJSON(json['statutContrat']),
        'statutInscription': !exists(json, 'statutInscription') ? undefined : ESearchStatutInscriptionListSearchFromJSON(json['statutInscription']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ApprenantHopeSearchToJSON(value?: ApprenantHopeSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nomSa': TextSearchToJSON(value.nomSa),
        'prenomSa': TextSearchToJSON(value.prenomSa),
        'anneeScolaireCriteria': TextSearchToJSON(value.anneeScolaireCriteria),
        'telephone': TextSearchToJSON(value.telephone),
        'gsm': TextSearchToJSON(value.gsm),
        'classeCriteria': FilterTextSearchToJSON(value.classeCriteria),
        'centreCriteria': StringListSearchToJSON(value.centreCriteria),
        'degreCriteria': StringListSearchToJSON(value.degreCriteria),
        'idapprenant': NumericSearchToJSON(value.idapprenant),
        'mesApprenants': EHopeApprenantSearchTypeListSearchToJSON(value.mesApprenants),
        'enrechercheEntreprise': BooleanSearchToJSON(value.enrechercheEntreprise),
        'metierContrat': StringListSearchToJSON(value.metierContrat),
        'metierCriteria': StringListSearchToJSON(value.metierCriteria),
        'stadeContrat': StringListSearchToJSON(value.stadeContrat),
        'stadeCriteria': StringListSearchToJSON(value.stadeCriteria),
        'serviceContrat': Int32ListSearchToJSON(value.serviceContrat),
        'typeContrat': StringListSearchToJSON(value.typeContrat),
        'registreNationalOrEmpty': TextSearchToJSON(value.registreNationalOrEmpty),
        'idpri': Int32ListSearchToJSON(value.idpri),
        'idari': Int32ListSearchToJSON(value.idari),
        'statutContrat': StringListSearchToJSON(value.statutContrat),
        'statutInscription': ESearchStatutInscriptionListSearchToJSON(value.statutInscription),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

